export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM6.935 6.383a.75.75 0 0 0-.812 1.083l1.523 2.922a.75.75 0 0 0 .694.402l4.582-.169-3.946 2.6a.75.75 0 0 0-.335.696l.352 3.747a.75.75 0 0 0 1.282.454l8.093-8.265a.75.75 0 0 0-.388-1.261L6.935 6.382Z"/>
</svg>
`;
